import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useUsersState = () => React.useContext(Context) || {}
export const useUsers = () => useUsersState()?.users || []

const QUERY = gql`
  query Users($page: Int, $search: String, $sort: UserSort, $filter: UserFilter) {
    users(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      email
      deleted
    }
  }
`

const UsersLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...filter, ignoreSegments: true }
    },
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default UsersLoader
